import { useCallback } from "react";

import { useFetchCfarOffersV2Light } from "./useFetchCfarOffersV2Light";

interface UseInitFlightsCfarOffersParams {
  currentFlight:
    | {
        tripId: string;
        fareId: string;
      }
    | undefined;
  onNoCurrentFlight?: () => void;
}

export const useInitFlightsCfarOffers = ({
  onNoCurrentFlight,
  currentFlight,
}: UseInitFlightsCfarOffersParams) => {
  const fetchLight = useFetchCfarOffersV2Light();

  const fetchOffers = useCallback(() => {
    if (
      currentFlight?.tripId === undefined ||
      currentFlight?.fareId === undefined
    ) {
      onNoCurrentFlight?.();
      return;
    }

    fetchLight(currentFlight.tripId, currentFlight.fareId);
  }, [
    fetchLight,
    onNoCurrentFlight,
    currentFlight?.tripId,
    currentFlight?.fareId,
  ]);

  return {
    fetchOffers,
  };
};
